<template>
  <v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
    <div class="text-right ma-3">
      <v-btn icon @click="$emit('cancel')">
        <v-icon large>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-row justify="center" align="center" class="pb-5">
      <v-col cols="16" class="text-center text-h4">
        <div>
          {{ newsItem.id ? "Редактирование новости" : "Создание новости" }}
        </div>
      </v-col>
    </v-row>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="formData.title"
              label="Заголовок"
              required
              outlined
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <label>Содержание</label>
            <news-rich-text-editor v-model="formData.content" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-file-input
              v-model="imageFile"
              label="Изображение"
              accept="image/*"
              prepend-icon="mdi-camera"
              outlined
              @change="onImageChange"
            />
            <v-img
              v-if="
                formData.image &&
                !imageFile &&
                typeof formData.image === 'string'
              "
              :src="getImageUrl(formData.image)"
              max-height="200"
              class="mt-2"
            />
            <v-btn
              v-if="formData.image"
              small
              color="error"
              class="mt-2"
              @click="deleteImage"
            >
              Удалить изображение
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-switch
              v-model="formData.active"
              label="Активна"
              color="primary"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="formData.expiresAt"
              label="Дата истечения (необязательно)"
              type="date"
              outlined
              clearable
              hint="После этой даты новость не будет показываться"
              persistent-hint
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center pb-5">
      <v-btn
        class="white--text"
        style="
          background-color: #d86568;
          width: 150px;
          height: 50px;
          border-radius: 50px;
        "
        @click="save"
        :disabled="!formData.title || !formData.content"
      >
        Сохранить
      </v-btn>
    </v-card-actions>
    <error-message-wrapper ref="error_wrapper" />
  </v-card>
</template>

<script>
import NewsRichTextEditor from "@/components/NewsRichTextEditor.vue";
import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";
import { SERVER_URI } from "@/api/NSApi";
import { mapGetters } from "vuex";

export default {
  name: "NewsForm",
  components: {
    NewsRichTextEditor,
    ErrorMessageWrapper,
  },
  computed: {
    ...mapGetters("modals", ["modalFormComponent"]),
    newsItem() {
      return this.modalFormComponent?.newsItem || {};
    },
  },
  data() {
    return {
      formData: {
        title: "",
        content: "",
        image: null,
        active: true,
        expiresAt: null,
      },
      imageFile: null,
    };
  },
  watch: {
    newsItem: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.formData = {
            title: newVal.title || "",
            content: newVal.content || "",
            image: newVal.image || null,
            active: newVal.active !== undefined ? newVal.active : true,
            expiresAt: newVal.expiresAt
              ? newVal.expiresAt.substring(0, 10)
              : null,
          };
          this.imageFile = null;
        } else {
          this.formData = {
            title: "",
            content: "",
            image: null,
            active: true,
            expiresAt: null,
          };
          this.imageFile = null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getImageUrl(imagePath) {
      if (!imagePath) return "";
      if (imagePath.startsWith("http")) return imagePath;
      if (imagePath.startsWith("/api/uploads")) return imagePath;
      return SERVER_URI + imagePath;
    },
    onImageChange(file) {
      if (file) {
        this.formData.image = file;
      }
    },
    deleteImage() {
      this.formData.image = null;
      this.imageFile = null;
      this.formData.deleteImage = true;
    },
    async save() {
      try {
        const newsData = {
          title: this.formData.title,
          content: this.formData.content,
          active: this.formData.active,
          scope: "internal",
          expiresAt: this.formData.expiresAt || null,
        };

        if (this.imageFile) {
          newsData.image = this.imageFile;
        }

        if (this.formData.deleteImage) {
          newsData.deleteImage = true;
        }

        const result = {
          ...newsData,
        };
        if (this.newsItem && this.newsItem.id) {
          result.id = this.newsItem.id;
        }
        this.$emit("confirm", result);
      } catch (error) {
        if (this.$refs.error_wrapper) {
          this.$refs.error_wrapper.showError(error);
        }
      }
    },
  },
};
</script>

<style scoped></style>
